import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/nav.scss";

let w = window;
let activeIndex = 0;

class NavScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeRef: null,
      mobileNav: false,
    };

    this.indicatorRef = React.createRef();

    this.setRef = this.setRef.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.positionIndicator = this.positionIndicator.bind(this);
  }

  handleSelection(el) {
    const xw = this.positionIndicator(el.target);
    this.indicatorRef.current.style.left = xw.left;
    this.indicatorRef.current.style.width = xw.width;
    activeIndex = el.target.tabIndex;
    this.props.handleSelection([activeIndex], true);
  }

  setRef(node) {
    if (this.state.activeRef !== node) {
      this.setState({ activeRef: node });
    }
  }

  positionIndicator() {
    if (this.state.activeRef) {
      return {
        width: this.state.activeRef.offsetWidth + "px",
        left: this.state.activeRef.offsetLeft + "px",
      };
    }
    return { width: "", left: "" };
  }

  componentDidMount() {
    if (this.indicatorRef.current.style.width === "") {
      this.forceUpdate();
    }
  }

  componentDidUpdate() {
   if (w["tools_category"] && activeIndex != 1) {
      activeIndex = 1;
      this.props.handleSelection([activeIndex], false);
      this.forceUpdate();
    }
  }

  render() {
    const position = this.positionIndicator();
    return (
      <div className="nav-tabs" style={{ textAlign: "center" }}>
        <nav className="nav">
          {this.props.navButtons.map((button, i) => (
            <a
              className={
                i === this.state.activeIndex
                  ? "nav-item active " + button.ref
                  : "nav-item " + button.ref
              }
              data-toggle="tab"
              role="tab"
              aria-controls={button.control}
              aria-selected="true"
              onClick={this.handleSelection}
              tabIndex={i}
              key={i}
              ref={i === activeIndex ? this.setRef : null}
            >
              <img
                className={"button-img"}
                src={button.tabImage}
                tabIndex={i}
              ></img>
              <div className="button-title" tabIndex={i}>
                {button.label}
              </div>
            </a>
          ))}
          <span
            style={{
              left: position.left,
              width: position.width,
              backgroundColor: this.props.navButtons[activeIndex].color,
            }}
            ref={this.indicatorRef}
            className="nav-indicator"
          ></span>
        </nav>
      </div>
    );
  }
}

export default NavScreen;
